/**
 * RESPONSIBILITY: the two things the home page may play behind its title.
 *
 * THESE STRINGS ARE STORED. A saved hero names its mode by this text, so renaming one
 * silently turns it into the default. Add freely; rename never.
 *
 * `Video` is the default, and what a hero saved before this field existed means: it had a
 * video, and it played it. Nothing had to be converted.
 */
export const HERO_MODE = {
  Video: 'Video',
  Show: 'Picture show',
} as const;

export const HERO_MODES = Object.values(HERO_MODE);

export const DEFAULT_HERO_MODE = HERO_MODE.Video;
